<div class="spot-details-page" *ngIf="details">
  <div
    class="hero-section"
    [ngStyle]="{ 'background-image': 'url(' + details.beachImage + ')' }"
  >
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1>{{ details.title }}</h1>
      <p>{{ details.description }}</p>
      <div class="info-line">
        <span
          style="cursor: pointer"
          (click)="openMapModal()"
          ngbTooltip="Click to view on Map"
        >
          <i class="bi bi-geo-alt-fill"></i>
          {{ details.address }}
        </span>
      </div>
    </div>
  </div>

  <div class="container main-content">
    <div class="row info-cards-row">
      <div class="col-lg-4 col-md-6 col-12 my-1">
        <div class="info-card">
          <i class="bi bi-calendar-date icon-green"></i>
          <div>
            <h5>Available Dates</h5>
            <p>
              {{ details.startDate | date : "yyyy-MM-dd" }} to
              {{ details.endDate | date : "yyyy-MM-dd" }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12 my-1">
        <div class="info-card">
          <i class="bi bi-calendar-date icon-green"></i>
          <div>
            <h5>Check-in & Check-out</h5>
            <p>{{ details.checkInTime }} to {{ details.checkOutTime }}</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12 my-1">
        <div class="info-card">
          <i class="bi bi-umbrella icon-green"></i>
          <div style="width: 100%">
            <h5>Timing</h5>
            <p>{{ details.timing }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center my-5">
      <h2 class="section-title">
        {{ details.categoryId.name ? details.categoryId.name : "-" }}
      </h2>
      <p style="font-size: larger">Choose Your Perfect Zone</p>
    </div>

    <div class="row">
      <div
        class="col-lg-6 mb-4"
        *ngFor="let zone of details.zones"
        [ngClass]="{ 'mx-auto': details.zones.length === 1 }"
      >
        <div class="zone-card">
          <div class="zone-image-container">
            <img
              [src]="zone.zoneImage"
              [alt]="zone.zoneName"
              class="zone-image"
            />
            <span class="spots-badge"
              >{{ getAvailableSlots(zone.slots) }} spots available</span
            >
          </div>
          <div class="zone-body">
            <div
              class="d-flex flex-column-reverse flex-sm-row justify-content-between align-items-start"
            >
              <div>
                <h3>{{ zone.zoneName }}</h3>
                <p
                  class="badge badge-warning badge-pill"
                  style="font-size: 12px"
                >
                  {{ getSubcategoryName(zone.subCategoryId) }}
                </p>
              </div>
              <div class="price w-100 w-auto">
                <h4 class="text-right">
                  {{ details.countryObject.currency }}
                  {{ zone.price }}
                </h4>
                <p class="vat-text" *ngIf="details.isExclusive">
                  +
                  {{ details.vatPercentage }}% VAT
                </p>
              </div>
            </div>

            <div class="details-section">
              <p class="included-title">Included:</p>
              <div>
                <span
                  class="asset-tag"
                  *ngFor="let asset of zone.assetsIncluded"
                  >{{ asset }}</span
                >
              </div>
            </div>

            <div
              class="d-flex justify-content-between text-muted mt-3 small-info"
            >
              <span
                ><i class="bi bi-grid-3x3"></i> {{ zone.numOfRows }} x
                {{ zone.numOfColumns }} layout</span
              >
            </div>
            <h6 class="mb-3 mt-4 fw-semibold">Slot Layout:</h6>
            <div class="layout-info">
              <div
                class="slots-grid"
                [style.grid-template-columns]="
                  'repeat(' + zone.numOfColumns + ', 1fr)'
                "
              >
                <ng-container
                  *ngFor="
                    let row of createGridLayout(zone);
                    let rowIndex = index
                  "
                >
                  <span
                    *ngFor="let slot of row; let colIndex = index"
                    class="slot-badge text-center"
                    [ngClass]="{
                      available: slot?.status === 'available',
                      booked: slot?.status === 'blocked',
                      pending: slot?.status === 'pending',
                      empty: !slot
                    }"
                    (click)="slot ? slotBooking(slot) : null"
                  >
                    {{ slot?.positionId || "—" }}
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container location-details-card card shadow-sm border-0 mb-4">
        <div class="card-body">
          <h4 class="section-title mb-4 border-bottom pb-2">
            <i class="bi bi-info-circle-fill me-2"></i> Other Details
          </h4>

          <div *ngIf="details.blockedDates.length > 0" class="mb-4">
            <h5>
              <i class="bi bi-calendar-x-fill text-danger me-2"></i> Blocked
              Dates:
            </h5>
            <div class="blocked-dates-list mt-2">
              <span
                *ngFor="let date of details.blockedDates"
                class="badge rounded-pill bg-danger-subtle text-danger fw-semibold px-3 py-2 shadow-sm"
                style="font-size: 14px"
              >
                {{ date }}
              </span>
            </div>
          </div>

          <div *ngIf="details.bookingLocationId" class="mb-2">
            <h5 class="text-dark">
              <i class="bi bi-map-fill text-warning me-2"></i> Location Service:
            </h5>
            <div class="card-body">
              <p class="textWrapper mb-3">
                <i class="bi bi-pin-map-fill me-2 text-primary"></i>
                {{ details.bookingLocationId.title }}
              </p>

              <p class="textWrapper mb-4">
                <i class="bi bi-geo-alt-fill text-danger me-2"></i>
                {{ details.bookingLocationId.address }}
              </p>

              <div *ngIf="details.bookingLocationId.services?.length > 0">
                <h6 class="text-dark fw-semibold mb-2">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  Services:
                </h6>
                <div class="d-flex flex-wrap gap-2">
                  <span
                    *ngFor="let service of details.bookingLocationId.services"
                    class="badge bg-success-subtle text-success fw-semibold px-3 py-2 shadow-sm"
                    style="font-size: 14px"
                  >
                    {{ service.serviceName }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="details.created_at" class="mb-4">
            <h5 class="text-dark">
              <i class="bi bi-clock-history text-primary me-2"></i> Spot Created
              Date:
            </h5>
            <p class="text-muted mb-0">
              {{ details.created_at | date : "fullDate" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #slotDetailsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Slot Information</h4>
      <button type="button" class="btn-close" (click)="modal.dismiss('Close')">
        <i class="icon-close">✕</i>
      </button>
    </div>
    <div class="modal-body">
      <div class="slot-details-container">
        <div class="slot-header">
          <h3>{{ slotDetails.positionId }}</h3>
          <span class="slot-status-badge" [ngClass]="slotDetails.status">
            {{ slotDetails.status | titlecase }}
          </span>
        </div>

        <div class="slot-info">
          <div class="info-item">
            <i class="bi bi-geo-alt"></i>
            <div>
              <h5>Zone</h5>
              <p>{{ slotDetails.zoneName }}</p>
            </div>
          </div>

          <div class="info-item">
            <i class="bi bi-calendar-range"></i>
            <div>
              <h5>Date Range</h5>
              <p>{{ slotDetails.startDate }} to {{ slotDetails.endDate }}</p>
            </div>
          </div>

          <div class="info-item">
            <i class="bi bi-clock"></i>
            <div>
              <h5>Timings</h5>
              <p>{{ slotDetails.startTime }} - {{ slotDetails.endTime }}</p>
            </div>
          </div>

          <div
            *ngIf="
              slotDetails.isBlockedDates && slotDetails.blockedDates?.length
            "
            class="info-item"
          >
            <i class="bi bi-calendar-x"></i>
            <div>
              <h5>Blocked Dates</h5>
              <div class="blocked-dates">
                <span
                  *ngFor="let date of slotDetails.blockedDates"
                  class="blocked-date"
                >
                  {{ date }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">
        Close
      </button>
      <button
        *ngIf="slotDetails?.status === 'available'"
        type="button"
        class="btn btn-danger"
        (click)="toggleSeat(slotDetails)"
      >
        Block Seat
      </button>

      <button
        *ngIf="slotDetails?.status === 'blocked'"
        type="button"
        class="btn btn-success"
        (click)="toggleSeat(slotDetails)"
      >
        Make Available
      </button>
    </div>
  </ng-template>

  <ng-template #mapModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Location on Map</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body map-modal-body"></div>
  </ng-template>
</div>
